import { render, staticRenderFns } from "./customerSide.vue?vue&type=template&id=2b6ccc90&"
import script from "./customerSide.vue?vue&type=script&lang=js&"
export * from "./customerSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports